import { autoWebViewJs } from '@droid/android';
import { useTranslation } from '@fanfanlo';
import { Button } from '@mui/material';

export function NotificationSettingButton() {
  const { t } = useTranslation('homepage/components/permissions/notification/content');
  function openSettings() {
    const script = `
                com.fanfanlo.lib.notification.NotificationReader.openNotificationAccessSettings()
                `;
    console.log('call opensettings');
    autoWebViewJs.callScript(script);
  }
  return (
    <Button
      onClick={openSettings}
      data-testid="NotificationSettingButton__settingButton__01JFQX8K9A0"
      data-test-comment="通知设置按钮，点击后打开系统通知访问设置"
    >
      {t('NotificationSettingButton.setting')}
    </Button>
  );
}
